import { useSearchParams } from "react-router-dom";
import { PublicMessage, PublicShell } from "@/components/checkins/public/PublicShell";

const WHAT = {
  invitation: "In a real email, this button opens the client's own progress review questionnaire.",
  summary: "In a real email, this button opens the client's traffic-light summary once it has been released.",
  manage: "In a real email, this link lets the client stop or change their progress review emails.",
};

export default function PublicProgressReviewDemo() {
  const [params] = useSearchParams();
  const what = WHAT[params.get("link")] || "In a real email, this link opens the client's own secure page.";
  return (
    <PublicShell testId="progress-review-demo-page">
      <PublicMessage title="This is a demo link" testId="progress-review-demo-message">
        <p>You opened a link from a <strong>test email</strong>. No client or progress review is attached to it.</p>
        <p data-testid="progress-review-demo-what">{what}</p>
        <p className="text-base text-zinc-500">You can close this tab.</p>
      </PublicMessage>
    </PublicShell>
  );
}
